import { render, staticRenderFns } from "./BuyHistory.vue?vue&type=template&id=029be0c4&scoped=true&"
import script from "./BuyHistory.vue?vue&type=script&lang=js&"
export * from "./BuyHistory.vue?vue&type=script&lang=js&"
import style0 from "./BuyHistory.vue?vue&type=style&index=0&id=029be0c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029be0c4",
  null
  
)

export default component.exports